import ProfileList from '../common/ProfileList';
import { useContext } from 'react';
import {TEXTS} from '../../../../core/texts';
import ExperienceListItem, { EXPERIENCE_QUERY_PARAM } from './ExperienceListItem';
import ExperienceOrEducationEntityModal
  from '../common/ExperienceOrEducationEntityModal/ExperienceOrEducationEntityModal';
import { FreelancerContext } from '../FreelancerEntity';

const ExperienceList = () => {
  const { user } = useContext(FreelancerContext);
  return(
    <ProfileList 
      list={user.freelancerProfile.experiences || []} 
      title={TEXTS.EXPERIENCE} 
      emptyListText={TEXTS.NOT_ADDED} 
      entityQueryParam={EXPERIENCE_QUERY_PARAM}
      ListItemComponent={ExperienceListItem} 
      EntityComponent={ExperienceOrEducationEntityModal}
    />
  )
};

export default ExperienceList;